import * as ngCore from '@angular/core'

// TODO: this should be in the input folder
@ngCore.Component({
  selector: 'atn-ds-toggle-button',
  standalone: true,
  styleUrls: ['./toggle-button.component.scss'],
  templateUrl: './toggle-button.component.html',
})
export class AtnDsToggleButtonComponent {
  /** Label input for toggle button */
  public labelSg = ngCore.input<string | undefined>(undefined, {
    alias: 'label',
  })

  /** The flag indicating if the toggle button is disabled */
  public disabledSg = ngCore.input<boolean | undefined>(false, {
    alias: 'disabled',
  })

  /** The flag indicating if the toggle button is active (checked) */
  public activeSg = ngCore.model<boolean>(false, { alias: 'active' })
}
